module.exports = __webpack_public_path__ + "static/media/truck.e419fa77.svg";